import React, { Component } from 'react';
import PropTypes from 'prop-types';
import update from 'react-addons-update';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Header, Segment, Container, Button, Form } from 'semantic-ui-react';
import moment from 'moment-timezone';
import { StaffInfoBlock, Commons, MyInfo } from 'components';
import * as cm_action from 'actions/commons';
import * as cp_action from 'actions/company';
import cm from 'helpers/commons';
import toastr from 'helpers/toastr';
import storage from 'helpers/storage';
import base64 from 'helpers/base64';

moment.tz.setDefault('Asia/Seoul');

const propTypes = {};

const defaultProps = {};

class UserInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      info: {
        signid: '',
        password: '',
        password2: '',
        passwordreset: 'Y',
        name: '',
        email: '',
        phone: '',
        position: '',
        comidnum: '',
        level: 0,
        group: '',
        rankposition: 0,
        depth: {
          one: 0,
          two: 0,
          three: 0
        }
      },
      isLoading: true,
      modal: null,
      historyModal: null
    };
  }

  componentWillMount() {
    cm.propsInit(this.props);

    this.getMyInfo();
  }

  componentDidMount() {
    cm.mainTitle('내정보 관리');
  }

  componentDidUpdate() {
    //semantic confirm button css change
    // if (this.state.confirmShow) {
    //   $('.confirm-model > .actions')
    //     .children()
    //     .eq(0)
    //     .attr('class', 'ui grey inverted button cancel');
    //   $('.confirm-model > .actions')
    //     .children()
    //     .eq(1)
    //     .attr('class', 'ui red button ok');
    // }
  }

  shouldComponentUpdate(nextProps, nextState) {
    let result = false;
    if (nextState !== this.state) {
      return true;
    } else {
      return false;
    }
  }

  // 내 정보 조회
  getMyInfo = async () => {
    const { cmAPI } = this.props;
    const company = storage.get('company');
    const { user } = company || {};
    if (!user) {
      this.goBack();
      return;
    }
    const params = {
      id: user.id
    };
    try {
      await cmAPI.staffSel(params);

      const { staffList } = this.props;
      const data = staffList.data.user;
      const info = {
        id: data.id,
        signid: data.signid ? data.signid : data.signid,
        password: '',
        password2: '',
        passwordreset: 'Y',
        name: data.name ? data.name : data.name,
        email: data.email.value ? data.email.value : '',
        emailAuth: data.email.auth ? data.email.auth : false,
        phone: data.phone.value ? data.phone.value : '',
        phoneAuth: data.phone.auth ? data.phone.auth : false,
        isCertification: data.isCertification ? data.isCertification : false,
        comidnum: data.comidnum ? data.comidnum : '',
        position: data.position ? data.position : '',
        level: data.level,
        group: data.group.idx,
        rankposition: data.rankposition ? data.rankposition.text : '',
        orgcodelist: data.orgcodelist ? data.orgcodelist : null,
        orgcode: data.orgcodelist ? data.orgcodelist[data.orgcodelist.length - 1] : null,
        auth: data.auth,
        grade: data.grade
      };
      this.setState({ info });

      this.setState({ isLoading: false });
    } catch (e) {
      const response = e.response;

      if (response) {
        toastr('top-right', 'warning', response.data.message);
        this.context.router.history.push('/main/staffManagement');
      }

      console.log('###### staffSel error : ', e);
    }
  };

  handleEvent = async (type, data) => {
    const { cmAPI } = this.props;

    this.setState({
      info: update(this.state.info, { [type]: { $set: data } })
    });
  };

  validation = () => {
    const { info } = this.state;
    const { type, id } = this.props.match.params;
    const { sex, position, groupIdx, depth, vitality } = this.props;
    console.log(info);
    const params = {
      signid: info.signid,
      name: info.name ? info.name : null,
      email: info.email ? info.email : null,
      phone: info.phone ? info.phone : null,
      level: vitality && vitality.value ? vitality.value : info.level ? info.level : 1,
      groupidx: groupIdx && groupIdx.value ? groupIdx.value : info.group,
      orgCode: depth && depth.value ? depth.value : null,
      rankposition: position && position.value !== 0 ? position.value : null,
      position: info.position ? info.position : null,
      comidnum: info.comidnum ? info.comidnum : null,
      passwordreset: info.passwordreset === 'Y' ? 'N' : 'Y'
    };

    params['id'] = info.id;
    let result = false;

    if (!info.signid) {
      toastr('top-right', 'warning', '아이디를 입력하세요.');
      return result;
    } else if (info.signid.length < 6 || info.signid.length > 40) {
      toastr('top-right', 'warning', '아이디는 6자 이상 40자 이하로 입력해주세요.');
      return result;
    }

    if (!info.name) {
      toastr('top-right', 'warning', '이름을 입력하세요.');
      return result;
    } else if (info.name.length > 30) {
      toastr('top-right', 'warning', '이름은 30자까지 입력 가능합니다.');
      return result;
    }

    if (info.email && !cm.validateEmail(info.email)) {
      toastr('top-right', 'warning', '이메일 형식이 아닙니다.');
      return result;
    }

    if (info.phone && !cm.validatePhone2(info.phone)) {
      toastr('top-right', 'warning', '휴대전화번호 형식이 아닙니다.');
      return result;
    }

    return params;
  };

  // 사용자 정보 수정
  editMyInfo = async () => {
    const params = this.validation();
    if (params.password) {
      params.password = base64.encode(params.password);
    }

    if (params !== false) {
      const { cpAPI } = this.props;
      try {
        console.log(params);
        await cpAPI.editMyInfo('put', params);
        toastr('top-right', 'success', '저장 되었습니다.');
      } catch (e) {
        const { response } = e;

        if (response) {
          toastr('top-right', 'error', response.data.message);
        }

        console.log('###### staffInfoAdd error : ', e);
      }
    }
  };

  // 사용자 비밀번호 초기화
  changePassword = async (pwd, rePwd) => {
    try {
      if (!pwd) {
        toastr('top-right', 'warning', '초기화 비밀번호를 입력하세요.');
        return;
      } else if (pwd !== rePwd) {
        toastr('top-right', 'warning', '재입력한 비밀번호가 일치하지 않습니다.');
        return;
      }

      const { cpAPI } = this.props;
      const { info } = this.state;
      const params = {
        id: info.id,
        password: base64.encode(pwd)
      };

      await cpAPI.staffPwdChange(params);
      toastr('top-right', 'success', '비밀번호가 초기화 되었습니다.');
      this.setState({
        modal: {
          open: false
        }
      });
    } catch (e) {
      const response = e.response;

      if (response) {
        toastr('top-right', 'warning', response.data.message);
      }

      console.log('###### changePassword error : ', e);
    }
  };

  // 사용자 비밀번호 변경
  changeMyPassword = async (prePassword, chgPassword1, chgPassword2) => {
    try {
      if (!prePassword) {
        toastr('top-right', 'warning', '현재 비밀번호를 입력해주세요.');
        return;
      }
      if (!chgPassword1) {
        toastr('top-right', 'warning', '변경할 비밀번호를 입력해주세요.');
        return;
      }
      if (!chgPassword2) {
        toastr('top-right', 'warning', '변경할 비밀번호를 재입력해주세요.');
        return;
      }
      if (chgPassword1 !== chgPassword2) {
        toastr('top-right', 'warning', '재입력한 비밀번호가 일치하지 않습니다.');
        return;
      }

      const { cpAPI } = this.props;
      const { info } = this.state;
      const params = {
        id: info.id,
        source: base64.encode(prePassword),
        target: base64.encode(chgPassword1)
      };

      await cpAPI.myPwdChange(params);
      toastr('top-right', 'success', '비밀번호가 변경되었습니다.');
      this.setState({
        modal: {
          open: false
        }
      });
    } catch (e) {
      const { response } = e;
      if (response) {
        toastr('top-right', 'warning', response.data.message);
      }
      console.log('###### changePassword error : ', e);
    }
  };

  // 페이지 이동
  goBack = () => {
    this.context.router.history.goBack();
  };

  // 모달팝업
  modal = (type, size) => {
    const data = {
      open: type,
      size,
      onOff: this.modal,
      changeMyPassword: this.changeMyPassword
    };

    this.setState({
      modal: data
    });
  };

  // 로그인 이력 확인
  loginHistory = (type, size) => {
    const data = {
      open: type,
      size,
      onOff: this.loginHistory
    };

    this.setState({
      historyModal: data
    });
  };

  render() {
    const { info, isLoading, modal, historyModal } = this.state;

    const button = {
      fn: {
        editMyInfo: this.editMyInfo,
        loginHistory: this.loginHistory,
        goBack: this.goBack
      },
      modal: { onOff: this.modal }
    };

    return (
      <main>
        <div className="search-box si">
          <Container fluid>
            {isLoading ? (
              <Commons.LoadingBar />
            ) : (
              <div>
                <MyInfo.Buttons position="top" fn={button.fn} modal={button.modal} />
                <Segment vertical className="title top">
                  <Header as="h2">개인정보</Header>
                </Segment>
                <Segment vertical className="personal">
                  <StaffInfoBlock.IndividualInfo handleEvent={this.handleEvent} type="det" info={info} />
                </Segment>
                <Segment vertical>
                  <MyInfo.Buttons position="bottom" fn={button.fn} />
                </Segment>
              </div>
            )}
            {modal ? (
              <MyInfo.ChangeMyPWD
                size={modal.size ? modal.size : null}
                open={modal.open}
                closeFn={modal.onOff}
                okFn={modal.changeMyPassword}
              />
            ) : null}
          </Container>
          {historyModal ? (
            <MyInfo.LoginHistory size={historyModal.size} open={historyModal.open} closeFn={historyModal.onOff} />
          ) : null}
        </div>
      </main>
    );
  }
}

UserInfo.contextTypes = {
  router: PropTypes.object.isRequired
};

UserInfo.propTypes = propTypes;
UserInfo.defaultProps = defaultProps;

export default connect(
  (state) => ({
    groupIdx: state.commons.group,
    depth: state.commons.depth,
    sex: state.commons.sex,
    auth: state.commons.auth,
    company: state.auth.company,
    vitality: state.commons.vitality,
    position: state.commons.position,
    staffList: state.commons.staff
  }),
  (dispatch) => ({
    cmAPI: bindActionCreators(
      {
        handleEvent: cm_action.ReduxDataSet,
        staffSel: cm_action.StaffSel,
        authInfo: cm_action.ReduxDataSet
      },
      dispatch
    ),

    cpAPI: bindActionCreators(
      {
        editMyInfo: cp_action.StaffAct,
        staffPwdChange: cp_action.StaffPwdChange,
        myPwdChange: cp_action.MyPwdChange
      },
      dispatch
    )
  })
)(UserInfo);
